export enum ModeloNegocioEnum {
  ParceriaLoteadora = 'Parceria com Loteadora',
  MrvAdquirenteLote = 'MRV adquirente do Lote'
}
